<template>
  <div v-if="monthlyDraw && monthlyDraw.is_active && monthlyDraw.banner_image" class="container mb-10">
    <NuxtLink :to="localePath('/monthly-draw')">
      <NuxtImg
        :src="monthlyDraw.banner_image"
        class="w-full rounded-lg shadow-lg cursor-pointer hover:opacity-90 transition-opacity"
        :alt="t('monthly_draw.banner_alt')"
      />
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();
const localePath = useLocalePath();
const BaseUrl = inject("BaseUrl") as string;
interface MonthlyDraw {
  is_active: boolean;
  banner_image?: string;
}
const monthlyDraw = ref<MonthlyDraw | null>(null);

const fetchMonthlyDraw = async () => {
  try {
    const data = await $fetch<Api>(`${BaseUrl}/monthly-draw`);
    if (data.data) {
      monthlyDraw.value = data.data;
    }
  } catch (error) {
    console.error("Error fetching monthly draw:", error);
  }
};

onMounted(() => {
  fetchMonthlyDraw();
});
</script>

